module.exports = __webpack_public_path__ + "img/out-pic2.9d11d3d0.png";